import React from "react";

import styles from "./appShell.module.css";

// 20 × 20 stroke paths from the app-shell design (Shell.dc.html, SH_ICONS): 1.6px stroke, round caps.
const PATHS = {
  home: ["M3 9.5 10 3.5l7 6V16a1 1 0 0 1-1 1h-3.5v-5h-5v5H4a1 1 0 0 1-1-1V9.5Z"],
  inbox: [
    "M3 11h4l1.5 2.5h3L13 11h4",
    "M3 11V5.5A1.5 1.5 0 0 1 4.5 4h11A1.5 1.5 0 0 1 17 5.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5V11Z"
  ],
  profile: ["M10 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z", "M3.5 17.5c0-3.3 2.9-5.5 6.5-5.5s6.5 2.2 6.5 5.5"],
  referrals: ["M4 7h10M11.5 4.5 14 7l-2.5 2.5", "M16 13H6M8.5 10.5 6 13l2.5 2.5"],
  community: ["M3 4.5h9v6H7l-3 2.5v-2.5H3v-6Z", "M14 8h3v6h-1v2.5L13 14H8.5v-1.5"],
  qa: ["M10 17.5a7.5 7.5 0 1 0-6.6-3.9L3 17l3.5-.9a7.5 7.5 0 0 0 3.5.9Z", "M8 8.2a2 2 0 1 1 2.8 1.8c-.5.3-.8.7-.8 1.2", "M10 13.5h.01"],
  paid: [
    "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    "M10 5.5v9",
    "M12.3 7.6c-.4-.6-1.2-1-2.3-1-1.4 0-2.4.7-2.4 1.6 0 2.3 4.8 1 4.8 3.3 0 .9-1 1.6-2.4 1.6-1.1 0-2-.4-2.4-1"
  ],
  probono: ["M10 16.5s-6.5-3.9-6.5-8.3A3.5 3.5 0 0 1 10 6a3.5 3.5 0 0 1 6.5 2.2c0 4.4-6.5 8.3-6.5 8.3Z"],
  orgs: [
    "M3.5 17.5h13",
    "M5 17.5V4.5A1.5 1.5 0 0 1 6.5 3h7A1.5 1.5 0 0 1 15 4.5v13",
    "M8 6.5h1M11 6.5h1M8 9.5h1M11 9.5h1M8 12.5h1M11 12.5h1",
    "M9 17.5V15h2v2.5"
  ],
  events: [
    "M3.5 6A1.5 1.5 0 0 1 5 4.5h10A1.5 1.5 0 0 1 16.5 6v9.5A1.5 1.5 0 0 1 15 17H5a1.5 1.5 0 0 1-1.5-1.5V6Z",
    "M3.5 8.5h13",
    "M7 3v3M13 3v3"
  ],
  jobs: [
    "M3.5 8A1.5 1.5 0 0 1 5 6.5h10A1.5 1.5 0 0 1 16.5 8v7a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 15V8Z",
    "M7.5 6.5V5A1.5 1.5 0 0 1 9 3.5h2A1.5 1.5 0 0 1 12.5 5v1.5",
    "M3.5 10.5h13"
  ],
  credit: ["M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z", "M10 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"],
  account: [
    "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    "M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4"
  ],
  notification: ["M5 13.5V9a5 5 0 0 1 10 0v4.5l1.5 1.5h-13L5 13.5Z", "M8.5 17a1.5 1.5 0 0 0 3 0"],
  payments: [
    "M3 6.5A1.5 1.5 0 0 1 4.5 5h11A1.5 1.5 0 0 1 17 6.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-7Z",
    "M3 8.5h14",
    "M6 12h3"
  ],
  team: [
    "M7.5 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    "M2.5 16c0-2.5 2.2-4.2 5-4.2s5 1.7 5 4.2",
    "M13 5.2a2.3 2.3 0 0 1 0 4.4M14.5 12.3c1.8.4 3 1.6 3 3.2"
  ],
  partners: [
    "M3.5 9h13v7A1.5 1.5 0 0 1 15 17.5H5A1.5 1.5 0 0 1 3.5 16V9Z",
    "M3 6.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1V9H3V6.5Z",
    "M10 5.5v12",
    "M10 5.5c-1-2.5-4.5-3-4.5-.5 0 .5 4.5.5 4.5.5Zm0 0c1-2.5 4.5-3 4.5-.5 0 .5-4.5.5-4.5.5Z"
  ],
  eye: ["M2.5 10s2.7-5 7.5-5 7.5 5 7.5 5-2.7 5-7.5 5-7.5-5-7.5-5Z", "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"],
  help: ["M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z", "M8 8.2a2 2 0 1 1 2.8 1.8c-.5.3-.8.7-.8 1.2", "M10 13.5h.01"],
  logout: ["M8 17.5H5A1.5 1.5 0 0 1 3.5 16V4A1.5 1.5 0 0 1 5 2.5h3", "M13 13.5 16.5 10 13 6.5", "M16.5 10H7.5"],
  chevron: ["M4 8l6 6 6-6"],
  collapse: ["M2.5 3.5h15v13h-15z", "M7.5 3.5v13M14.5 8l-2 2 2 2"],
  expand: ["M2.5 3.5h15v13h-15z", "M7.5 3.5v13M11.5 8l2 2-2 2"],
  menu: ["M4 7h12M4 12h12M4 17h12"],
  close: ["M4 4l12 12M16 4L4 16"],
  search: ["M9 15.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z", "M14 14l3.5 3.5"]
};

/** An inline 20 × 20 icon, drawn in the current text colour. Decorative: the control that holds it carries the name. */
export const ShellIcon = ({ name, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false" className={styles.icon}>
    {(PATHS[name] || PATHS.home).map(d => (
      <path key={d} d={d} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    ))}
  </svg>
);
